import React from 'react';
import { CloseOutlined } from '@ant-design/icons';
import { Button, Tooltip, Typography, theme, Tabs } from 'antd';
import type { TabsProps } from 'antd';
import AIAssistant from './AIAssistant';
import { useAppDispatch } from '@/hooks/hooks';
import { toggleAIAssistant } from '@/store/slices/common/commonSlice';
import FAQ from '@/components/FAQ/indext';

const items: TabsProps['items'] = [
  {
    key: '1',
    label: 'Odin AI Assistant',
    children: <AIAssistant />,
  },
  {
    key: '2',
    label: 'FAQ',
    children: (
      <div style={{ padding: '0 1.5rem' }}>
        <FAQ />
      </div>
    ),
  },
];

const Assistant = () => {
  const dispatch = useAppDispatch();
  const handleCloseAssistant = () => {
    dispatch(toggleAIAssistant());
  };
  const onChange = (key: string) => {
    console.log(key);
  };
  return (
    <div className="assistant-sidebar">
      <Tooltip title="Close">
        <Button
          type="text"
          onClick={handleCloseAssistant}
          shape="circle"
          icon={<CloseOutlined />}
          style={{ position: 'absolute', right: '9px', top: '5px', zIndex: 9 }}
        />
      </Tooltip>
      <Tabs
        defaultActiveKey="1"
        items={items}
        onChange={onChange}
        tabBarStyle={{ padding: '0 1rem' }}
      />
    </div>
  );
};

export default Assistant;
